export const environment = {
  production: true,
  name: "Dev",
  host: "https://api.dev.inscyd.com/",
  api: "https://api.dev.inscyd.com/api/",
  serverURL: "https://api.dev.inscyd.com/",
  v1URL: "https://api.dev.inscyd.com/",
  stravaClientId: "107217",
  stripeKey: "pk_test_53PksKIm7gVzMrlVIL9ncuk8",
  mixpanelToken: "1ad2913e085bd47d7ce1b5a734ff842f",
  dataSecretKey: "a33fbsNIwSZF-ApfF-b9mnuHwg6yH4ayjET8cidJsFE=",
  signatureSecretKey: "VSsqN5LoQRX87h6kRVcrylmHkrGCvXnAZHJUKZSd8dE=",
};
